import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';

interface caseUploadedMedicalRecordsState {
  uploadingDocumentIds: string[];
}

const initialState: caseUploadedMedicalRecordsState = {
  uploadingDocumentIds: []
};

const caseUploadedMedicalRecordsSlice = createSlice({
  name: 'caseUploadedMedicalRecords',
  initialState: initialState,
  reducers: {
    setUploadingDocumentIds: (state, action: PayloadAction<string[]>) => {
      state.uploadingDocumentIds = action.payload;
    }
  }
});

export const { setUploadingDocumentIds } = caseUploadedMedicalRecordsSlice.actions;

export const selectUploadingDocumentIds = (state: RootState) => {
  return state.caseUploadedMedicalRecords.uploadingDocumentIds;
};

export const caseUploadedMedicalRecordsReducer = caseUploadedMedicalRecordsSlice.reducer;
